import React from "react";

import Background from "../../../assets/cafe/cafe-select.png";
import ImageA from "../../../assets/cafe/cafe-option-a.png";
import ImageB from "../../../assets/cafe/cafe-option-b.png";

import GameSelectionLayout from "../GameSelectionLayout";

const CafePage2 = ({ setCurrentPage, setGarbageQtty }) => {
  const handleClickA = () => {
    setCurrentPage("cafe-3");
  };

  const handleClickB = () => {
    setGarbageQtty((prev) => prev + 2);
    setCurrentPage("cafe-4");
  };

  return (
    <GameSelectionLayout
      bg={Background}
      imageA={ImageA}
      textA="텀블러"
      onClickA={handleClickA}
      imageB={ImageB}
      textB="일회용컵"
      onClickB={handleClickB}
      currentIndex={0}
    >
      텀블러를 써야 좋긴 한데…
      <br />
      키오스크에는 텀블러 옵션이 없네.
      <br />
      텀블러 헹구기 귀찮기도 한데.
      <br />
      늦을 거 같은데 어떡하지?
    </GameSelectionLayout>
  );
};

export default CafePage2;
